import React, { useCallback } from "react";
import {AccordionItem} from 'react-light-accordion';
import Table from "../../../common/table/table";
import { ShiftReportHoursStyle } from "./shiftReportHoursStyle";
import shiftReportTableColumns from './shiftReportTableColumns';
import {isEmpty} from "lodash";
import styled from 'styled-components';

const AccordionItemContainer = styled.div`
    & .accordion-item .title {
        font-size: 1.5rem;
    }
`

const ShiftReportAccordion = ({title, data}) => {
    const getTableTitle = useCallback((item) => {
        if (item.rig === 'Summary') {
            return <h4>{title} {item.rig}</h4>;
        }

        return <h4>{item.rig + (isEmpty(item.shift) ? '' : '-') + item.shift}</h4>;
    }, [title])

    return (
        <AccordionItemContainer>
            <AccordionItem className="card-header bg-primary" title={title}>
                <div className="p-4">
                {data.map((item) => {
                return (
                    <div key={item.rig+'_'+ item.shift}>
                        <div className="row">
                            {title !== 'General Summary' ? getTableTitle(item) : null}
                        </div>
                        <div className="row">
                            <div className="col-sm-12">
                                <ShiftReportHoursStyle>
                                    <Table
                                        columns={shiftReportTableColumns(item, title)}
                                        data={item.table_body}
                                        exportOptions={{
                                            pdf: false,
                                            xlsx: true,
                                            csv: false,
                                        }}
                                        getExportFileName={() => "shift_entry_time"}
                                        isSortDisabled
                                    />
                                </ShiftReportHoursStyle>
                            </div>
                        </div>
                    </div>        
                    )
                })}
                </div>
            </AccordionItem>
        </AccordionItemContainer>
    )
}

export default ShiftReportAccordion;
